module.exports = __webpack_public_path__ + "static/media/cake-topper@2x.4edd2836.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/cake-topper@2x.jpg
// module id = 475
// module chunks = 0